import { post } from '@/utils/request'

export default {
    // 轮播图片
    banner(data) {
        return post('/banner/list.html',data)
    },
    // 关于我们
    about(data){
        return post('/company/profile.html',data)
    },
    // 发展历程
    history(data){
        return post('/company/process.html',data)
    },
    // 业务与服务
    serList(data){
        return post('/company/getbs.html',data)
    },
    // 业务与服务详情
    serInfo(data){
        return post('/company/bsDetail.html',data)
    },
    // 经典案例列表
    caseList(data){
        return post('/company/cases.html',data)
    },
    // 经典案例详情
    caseInfo(data){
        return post('/company/caseDetail.html',data)
    },
    // 合作品牌
    cooperate(data){
        return post('/company/cooperate.html',data)
    },
    // 新闻资讯
    newsList(data){
        return post('/company/news.html',data)
    },
    // 新闻资讯详情
    newsInfo(data){
        return post('/company/newsDetail.html',data)
    },
    // 联系我们
    conList(data){
        return post('/company/contactus.html',data)
    },
    // 加入我们
    joinList(data){
        return post('/company/joinus.html',data)
    },
}